// █▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀█
// █        JESSE STEWART         █
// █        UX/UI Designer        █
// █     www.JesseStewart.com     █
// █                              █
// █   (c) All Rights Reserved    █
// █▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄█

// TODO:
// - Swipe Controls
// - Keyboard Controls

import React from "react";
/** @jsx jsx */ import { css, jsx } from "@emotion/core";
import styled from "@emotion/styled";
import {
  // Import Const
  sizes,
  breakpoints,
  // Import Functions
  typeSet,
  padding,
  expandValue,
  transition
} from "../../helpers/theme";

import Swipe from "react-easy-swipe";
import { HotKeys } from "react-hotkeys";

var $ = require("jquery");
var tinycolor = require("tinycolor2");

let LightboxStyles = props => css`
  z-index: 500;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  overflow: hidden;

  /* Furious clickers won't highlight text */
  -webkit-user-select: none; /* Chrome/Safari */        
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* IE10+ */

  .closeLayer {
    min-height: 100vh;
  }

  .scroller {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    overflow-x: hidden;
    overflow-y: scroll;
    text-align: center;
    // Hide Scrollbars
    -ms-overflow-style: none !important;
    overflow: -moz-scrollbars-none !important;
    overscroll-behavior-y: contain;
    &::-webkit-scrollbar {
      display: none !important;
    }
    @media (min-width: ${expandValue(breakpoints[3])}) {
      padding: ${expandValue(sizes.space * 2)};
    }
  }
  .bg {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    ${transition("all", sizes.timer * 2 + "ms")}
    background: ${tinycolor("#000000")
      .setAlpha(0.9)
      .toRgbString()};
    ${props.bg && "background: " + props.bg};
  }
  img.fullImg {
    position: relative;
    width: 100%;
    margin: 0 auto;
    max-width: 100%;
    display: block;
    box-shadow: none;
    ${props.size === "mobile" && "max-width: 512px;"}
    ${props.size === "tablet" && "max-width: 1024px;"}
    ${props.size === "web" && "max-width: 1440px;"}
    ${props.size === "weblg" && "max-width: 1920px;"}
  }
  .counter {
    ${padding(
      "all",
      expandValue((sizes.space + sizes.cap) * 0.5) +
        " " +
        expandValue(sizes.space) +
        " " +
        expandValue((sizes.space - sizes.cap) * 0.5)
    )}
    background: ${tinycolor(props.theme.colors.black)
      .setAlpha(0.6)
      .lighten(25)
      .toRgbString()};
    height: ${expandValue(sizes.space * 2)};
    ${typeSet(sizes.fontSize)}
    position: fixed;
    right: ${expandValue(sizes.space * 2)};
    top: 0;
    display: flex;
    align-items: center;
    text-align: center;
    opacity: 0.6;
  }
  .nextButton {
    position: absolute;
    right: 0;
    top: 50%;
    width: ${expandValue(sizes.space * 2)};
    height: ${expandValue(sizes.space * 4)};
    transform: translateY(-50%) translateX(${expandValue(sizes.space * 0.25)});
    background: ${tinycolor(props.theme.colors.black)
      .setAlpha(0.6)
      .lighten(25)
      .toRgbString()};
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: ${expandValue(sizes.space)};
    border-radius: 50% 0 0 50%;
    ${transition("all", sizes.timer + "ms")}
    &:hover {
      transform: translateY(-50%) translateX(0);
      background: ${tinycolor(props.theme.colors.primary)
        .setAlpha(0.6)
        .toRgbString()};
    }
  }
  .prevButton {
    position: absolute;
    left: 0;
    top: 50%;
    width: ${expandValue(sizes.space * 2)};
    height: ${expandValue(sizes.space * 4)};
    transform: translateY(-50%) translateX(-${expandValue(sizes.space * 0.25)});
    background: ${tinycolor(props.theme.colors.black)
      .setAlpha(0.6)
      .lighten(25)
      .toRgbString()};
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: ${expandValue(sizes.space)};
    border-radius: 0% 50% 50% 0%;
    ${transition("all", sizes.timer + "ms")}
    &:hover {
      transform: translateY(-50%) translateX(0);
      background: ${tinycolor(props.theme.colors.primary)
        .setAlpha(0.6)
        .toRgbString()};
    }
  }
  .closeButton {
    position: absolute;
    right: 0;
    top: 0;
    width: ${expandValue(sizes.space * 2)};
    height: ${expandValue(sizes.space * 2)};
    background: ${tinycolor(props.theme.colors.black)
      .setAlpha(0.6)
      .lighten(25)
      .toRgbString()};
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: ${expandValue(sizes.space)};
    ${transition("background", sizes.timer + "ms")}
    &:hover {
      background: ${tinycolor(props.theme.colors.primary)
        .setAlpha(0.6)
        .toRgbString()};
    }
  }
`;
let LightboxStyled = styled("div")`
  ${LightboxStyles}
`;

let ThumBoxStyles = props => css`
  img.thumImg {
    cursor: zoom-in;
  }
`;
let ThumBoxStyled = styled("div")`
  ${ThumBoxStyles}
`;

let swipeDistance = 0;

export class Lightbox extends React.Component {
  constructor(props) {
    super();
    this.state = {
      isShowing: false,
      currentIndex: props.currentIndex,
      totalImages: props.images.length - 1
    };
  }

  componentWillUnmount = () => {
    $("body").removeClass("noScroll");
  };

  openModalHandler = () => {
    this.setState({
      isShowing: true,
      currentIndex: this.props.currentIndex
    });
    $("body").addClass("noScroll");
  };

  closeModalHandler = () => {
    this.setState({
      isShowing: false
    });
    $("body").removeClass("noScroll");
  };

  goToPrevSlide = () => {
    if (this.state.currentIndex === 0) {
      this.setState({
        currentIndex: this.state.totalImages
      });
    } else {
      this.setState({
        currentIndex: this.state.currentIndex - 1
      });
    }
  };

  goToNextSlide = () => {
    if (this.state.currentIndex === this.state.totalImages) {
      this.setState({
        currentIndex: 0
      });
    } else {
      this.setState({
        currentIndex: this.state.currentIndex + 1
      });
    }
  };

  onSwipeMove = position => {
    swipeDistance = position.x;
  };
  onSwipeEnd = () => {
    // Check to see if this was an intentional scroll or not
    if (swipeDistance > 100) {
      this.goToPrevSlide();
    }
    if (swipeDistance < -100) {
      this.goToNextSlide();
    }
    swipeDistance = 0;
  };

  render() {
    let size = null;
    if (this.props.images[this.state.currentIndex].size) {
      size = this.props.images[this.state.currentIndex].size;
    }

    let bg = null;
    if (this.props.images[this.state.currentIndex].bg) {
      bg = this.props.images[this.state.currentIndex].bg;
    }

    let alt = "";
    if (this.props.images[this.state.currentIndex].alt) {
      alt = this.props.images[this.state.currentIndex].alt;
    }

    const keyMap = {
      MOVE_LEFT: "left",
      MOVE_RIGHT: "right",
      EXIT: "escape, space, pagedown"
    };

    const handlers = {
      MOVE_LEFT: event => this.goToPrevSlide(),
      MOVE_RIGHT: event => this.goToNextSlide(),
      EXIT: event => this.closeModalHandler()
    };

    return (
      <ThumBoxStyled>
        <img
          src={this.props.images[this.props.currentIndex].image}
          onClick={this.openModalHandler}
          alt={alt}
          className="thumImg"
        />
        {this.state.isShowing && (
          <LightboxStyled isShowing={this.state.isShowing} size={size} bg={bg}>
            <HotKeys
              focused={true}
              attach={window}
              keyMap={keyMap}
              handlers={handlers}
            >
              <div className="bg" />
              <div className="scroller">
                <Swipe
                  onSwipeMove={this.onSwipeMove}
                  onSwipeEnd={this.onSwipeEnd}
                >
                  <div className="closeLayer" onClick={this.closeModalHandler}>
                    <img
                      src={this.props.images[this.state.currentIndex].image}
                      alt={alt}
                      className="fullImg"
                    />
                  </div>
                </Swipe>
              </div>
              <div className="counter">
                {this.state.currentIndex + 1} / {this.state.totalImages + 1}
              </div>
              <div className="closeButton" onClick={this.closeModalHandler}>
                X
              </div>
              <div className="prevButton" onClick={this.goToPrevSlide}>
                &lt;
              </div>
              <div className="nextButton" onClick={this.goToNextSlide}>
                &gt;
              </div>
            </HotKeys>
          </LightboxStyled>
        )}
      </ThumBoxStyled>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Partials/Lightbox.js